<template>
    <MainContent title="Importaciones">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center w-100 mb-3">
                <h3 class="card-title pt-2 mb-0">Importaciones</h3>
                <div class="card-tools">
                    <router-link
                        :to="{ name: 'back.emails.importaciones.crear' }"
                        class="btn btn-primary"
                    >
                        <i class="fas fa-plus mr-3"></i>
                        <span>Nueva importación</span>
                    </router-link>
                </div>
            </div>
        </template>        
        <template v-slot:content>
            <div v-if="loading" class="text-center my-5">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-3">Cargando...</p>
            </div>
            <b-row v-else>
                <b-col cols="12">
                    <ContainerTable :data="importaciones.data" :responsive="esMovil">
                        <b-table
                            hover
                            :items="importaciones.data"
                            :fields="fields"
                            :busy="loading"
                            empty-text="No hay importaciones registradas"
                        >
                            <template #cell(nombre_archivo)="{ item }">
                                <span>{{ item.nombre_archivo }}</span>
                            </template>
                            <template #cell(created_at)="{ item }">
                                <span>{{ item.created_at }}</span>
                            </template>
                            <template #cell(estado_importacion_texto)="{ item }">
                                <b-alert
                                    show
                                    :variant="getEstadoVariant(item.estado_importacion)"
                                    class="p-1 mb-0"
                                    style="width: 110px; margin-left: auto; margin-right: auto"
                                >
                                    <i :class="getEstadoIcon(item.estado_importacion)" class="mr-1"></i>
                                    {{ item.estado_importacion_texto }}
                                </b-alert>
                            </template>
                            <template #cell(opciones)="{ item }">
                                <OpcionesDropdownTableComponent
                                    :options="[
                                        { to: { name: 'back.emails.importaciones.show', params: { id: item.id }}, label: 'Ver detalles' }
                                    ]"
                                />
                            </template>
                        </b-table>
                    </ContainerTable>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>
<script>
    import MainContent from "@/components/backend/components/MainContent";
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    export default {
        components: {
            MainContent,
            ContainerTable,
            OpcionesDropdownTableComponent
        },
        data() {
            return {
                loading: false,
                importaciones: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 }
                },
                fields: [
                    { key: "nombre_archivo", label: "Nombre del archivo" },
                    { key: "created_at", label: "Fecha de importación", class: "text-center" },
                    { key: "estado_importacion_texto", label: "Estado", class: "text-center" },
                    { key: "opciones", label: "Opciones", class: "text-center" }
                ]
            };
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        methods: {
            async getImportaciones() {
                this.loading = true;
                try {
                    const response = await apiService.getListadoImportaciones();
                    this.importaciones = response;
                } catch(error) {
                    this.$toast.error("Error al cargar las importaciones");
                } finally {
                    this.loading = false;
                }
            },
            getEstadoVariant(estado) {
                switch(estado) {
                    case '0': return 'warning'; 
                    case '1': return 'info'; 
                    case '2': return 'success';  
                    case '3': return 'danger';
                    default: return 'secondary';
                }
            },
            getEstadoIcon(estado) {
                switch(estado) {
                    case '0': return 'fas fa-clock';        
                    case '1': return 'fas fa-spinner fa-spin';  
                    case '2': return 'fas fa-check-circle';  
                    case '3': return 'fas fa-times-circle';
                    default: return 'fas fa-question-circle';
                }
            }
        },
        created() {
            this.getImportaciones();
        },
    };
</script>
<style scoped>
.b-table .alert {
    display: inline-block;
    text-align: center;
}

.loading-container {
    padding: 30px 0;
}

.spinner-container {
    margin-bottom: 15px;
}

.loading-text {
    color: #6c757d;
    font-size: 1.1rem;
}
</style>